import {withRouter} from 'react-router';
import {lifecycle} from 'recompose';

// Remet la fenêtre en haut à chaque changement de route, afin d'arriver
// en haut de la nouvelle page plutôt qu'à la position de scroll précédente.
const ScrollToTop = () => null;

export default ScrollToTop
  |> lifecycle({
    componentDidUpdate({location: {pathname: prevPathname}}) {
      if (this.props.location.pathname !== prevPathname) {
        window.scrollTo(0, 0);
      }
    },
  })
  |> withRouter;
